<template>
    <NuxtLayout
        name="new-branded-funnel"
        :disable-side-content="route.meta.disableSideContent"
        :disable-footer="route.meta.disableFooter"
        :hide-shapes="route.meta.hideShapes"
    >
        <NuxtPage ref="page" />
        <template #sidecontent>
            <SideContentLoader />
        </template>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {useRoute} from 'vue-router';
    import {definePageMeta, navigateTo, useAmplitudeSessionReplay, useEvent} from '#imports';
    import SideContentLoader from '~/components/funnel/sidecontent/SideContentLoader.vue';
    import {usePageSourceStore} from '~/store/page-source.store';
    import {useSignupStore} from '~/store/signup.store';

    definePageMeta({
        layout: false,
    });

    // Composables
    const route = useRoute();

    // Stores
    const signupStore = useSignupStore();
    const pageSourceStore = usePageSourceStore();
    pageSourceStore.initPageSourceIfNeeded(route);
    useAmplitudeSessionReplay();

    // Events handlers
    useEvent('funnel:cancel', async () => {
        if (await signupStore.cancelSignup()) {
            navigateTo('/', {external: true});
        }
    });
</script>
